import { useEffect, useState, useRef } from "react";

/**
 * Floating "Zu Sichtbar Gut Bewertet" pill for patrice.studio pages.
 * Mirror of SGBReturnPill — links to the separate sichtbargutbewertet.de domain.
 * Whisper-tooltip on hover.
 */
export const StudioToSGBPill = () => {
  const [visible, setVisible] = useState(false);
  const [pastHero, setPastHero] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      setPastHero(y > 380);
      setVisible(false);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setVisible(true), 750);
    };

    timerRef.current = setTimeout(() => setVisible(true), 1200);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const show = visible && pastHero;

  return (
    <a
      href="https://sichtbargutbewertet.de"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="studio-to-sgb-pill"
      aria-label="Zu Sichtbar Gut Bewertet"
      className="group fixed right-0 top-1/2 -translate-y-1/2 z-40 select-none"
      style={{
        opacity: show ? 1 : 0,
        transform: `translate(${show ? "0" : "12px"}, -50%)`,
        transition: "opacity 700ms ease-out, transform 700ms cubic-bezier(.2,.7,.2,1)",
        pointerEvents: show ? "auto" : "none",
      }}
    >
      {/* Whisper tooltip — hover-triggered, 800ms total */}
      <span
        data-testid="studio-to-sgb-pill-tooltip"
        className="pointer-events-none absolute right-full top-1/2 -translate-y-1/2 mr-4 whitespace-nowrap px-3 py-2 italic-serif text-depth opacity-0 group-hover:animate-[pillWhisper_800ms_ease-out_forwards]"
        style={{
          background: "rgba(250, 247, 242, 0.92)",
          border: "1px solid rgba(255, 113, 0, 0.45)",
          fontFamily: "'Cormorant Garamond', serif",
          fontStyle: "italic",
          fontSize: "0.95rem",
          letterSpacing: "0.01em",
          boxShadow: "0 8px 32px rgba(40,0,27,0.18)",
          backdropFilter: "blur(8px)",
        }}
      >
        Sichtbar. Gut Bewertet
        <span className="ml-1" style={{ color: "#FF7100" }}>→</span>
      </span>

      <div
        className="flex items-center gap-3 py-6 pl-3 pr-2 backdrop-blur-md border border-depth/30 border-r-0 hover:border-depth/70 hover:pr-3 transition-all duration-500"
        style={{
          background: "rgba(250, 247, 242, 0.78)",
          borderTopLeftRadius: "999px",
          borderBottomLeftRadius: "999px",
        }}
      >
        <span
          aria-hidden
          className="block w-1.5 h-1.5 rounded-full"
          style={{ background: "#FF7100" }}
        />
        <span
          className="font-mono text-[0.62rem] tracking-[0.32em] uppercase text-depth/95 group-hover:text-depth transition-colors"
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
        >
          sichtbargutbewertet
        </span>
        <span
          aria-hidden
          className="font-mono text-depth/80 group-hover:text-depth transition-all duration-500 group-hover:-translate-y-0.5"
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)", fontSize: "0.62rem" }}
        >
          ↗
        </span>
      </div>
    </a>
  );
};

export default StudioToSGBPill;
